import { ActivatedRouteSnapshot } from '@angular/router';

/** Walks the route tree for the `:schoolId` param (calculator child routes inherit it from the parent). */
export function schoolIdFromRoute(route: ActivatedRouteSnapshot): string {
  let current: ActivatedRouteSnapshot | null = route;
  while (current) {
    const schoolId = current.paramMap.get('schoolId');
    if (schoolId) {
      return schoolId;
    }
    current = current.parent;
  }
  return '';
}
